import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "children", "Render"];
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { subscribe, getState } from '@/store';
import { isPreviewMode, isSimulateMode } from '@/utils/tool';
import { POLICY_INFO } from '@/constants';
import { useBehavior } from '../../hooks';
const Success = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    children,
    Render
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const cls = classnames({
    'components-success-render': true,
    [className]: !!className
  });
  const behavior = useBehavior();
  const [policyInfo = {}, setPolicyInfo] = useState({});
  const {
    issueStatus
  } = policyInfo;
  const {
    resultStatus = 0
  } = behavior;
  useEffect(() => {
    const fn = () => {
      setPolicyInfo(getState(POLICY_INFO) || {});
    };

    fn();
    subscribe(fn, POLICY_INFO);
  }, []);

  if (isPreviewMode() || isSimulateMode()) {
    // 成功 0
    if (Number(resultStatus) !== 0) {
      return null;
    }
  } else if (issueStatus !== 'success') {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), /*#__PURE__*/React.createElement(Render, {
    components: children
  }));
});
export default Success;